import { Component, OnInit } from '@angular/core';
import { ClientService } from '@app-services/client.service';
import { PageControl } from '@app-model/page-control';
import { ClientList } from '@app-model/client';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { environment } from '@env/environment';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
	selector: 'app-clients',
	templateUrl: './clients.component.html',
	styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {
	loading = false;
	initialLoad = true;
	searching = false;
	openFilter = false;
	searchTerm = '';
	formSearch = new FormGroup({
		search: new FormControl('')
	});

	list: ClientList[] = [];

	readonly columns = [
		{ key: 'name', header: "client.client", sortable: true, align: 'left' },
		{ key: 'permalink', header: 'client.permalink', sortable: true, align: 'left' },
		{ key: 'domain', header: 'client.domain', sortable: true, align: 'left' },
	];

	pageControl: PageControl = {
		limit: 10,
		page: 0,
		orderField: 'name',
		order: 'DESC',
		count: 0
	};

	constructor(private clientService: ClientService, private translate: TranslateService) { }

	ngOnInit() {
		this.getResults();
	}

	onClickOrderBy(slug: string, order: boolean) {
		if (!order) {
			return;
		}

		if (this.pageControl.orderField === slug) {
			this.pageControl.order = this.pageControl.order === 'ASC' ? 'DESC' : 'ASC';
		} else {
			this.pageControl.order = 'ASC';
			this.pageControl.orderField = slug;
		}
		this.pageControl.page = 0;
		this.getResults();
	}

	private getResults() {
		this.loading = true;

		this.clientService
			.paginate(this.pageControl, this.searchTerm)
			.pipe(
				finalize(() => {
					this.loading = false;
					this.initialLoad = false;
					this.searching = false;
				})
			)
			.subscribe(
				response => {
					this.pageControl.count = response.totalElements;
					this.list = this.pageControl.page === 0 ? response.data : [...this.list, ...response.data];
					this.pageControl.hasMore = response.actualPage < response.numberOfPages - 1;
				},
				err => {
					if (this.pageControl.page === 0) {
						this.list = [];
						this.pageControl.count = 0;
					} else {
						this.pageControl.page = Math.max(0, this.pageControl.page - 1);
					}
					console.error('Error fetching clients', err);
				}
			);
	}

	onSearch() {
		this.searching = true;
		this.searchTerm = this.formSearch.value.search;
		this.pageControl.value = this.formSearch.value.search
		this.pageControl.param = 'description';
		this.pageControl.page = 0;
		this.getResults();
	}

	loadMore(): void {
		this.pageControl.page++;
		this.getResults();
	}

	handleUrl(link: string): string {
		if (!link) return '--'
		return link[0] == '/' ? environment.url + link : environment.url + '/' + link;
	}

	copyLink(url?: string) {
		if(url) navigator.clipboard.writeText(url);
	}
}
